import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';
import Modal from '../../../Components/Modal/Modal';
import { IoMdArrowRoundBack, IoMdClose } from "react-icons/io";
import { FaCircleCheck, FaCircleXmark } from "react-icons/fa6";
import OTPInput from 'react-otp-input';
import './OTPInput.css';
import { NumericFormat } from 'react-number-format';
import moment from 'moment-jalaali';
import { useTelegram } from '../../../hooks/auth/useTelegram';
import { toast } from 'react-toastify';
import PhoneAccessComponent from './PhoneAccessComponent';
import ReactLoading from 'react-loading';
import api from '../../../hooks/api';
import RegisterSkeleton from './RegisterSkeleton';
import TelegramSafeArea from '../../../Components/TelegramSafeArea';
import { validateNationalCode } from './nationalCodeHelper';

const lifeTime = 120;
const days = Array.from({ length: 31 }, (_, i) => i + 1);
const months = [
    { id: 1, title: "فروردین" }, { id: 2, title: "اردیبهشت" }, { id: 3, title: "خرداد" },
    { id: 4, title: "تیر" }, { id: 5, title: "مرداد" }, { id: 6, title: "شهریور" },
    { id: 7, title: "مهر" }, { id: 8, title: "آبان" }, { id: 9, title: "آذر" },
    { id: 10, title: "دی" }, { id: 11, title: "بهمن" }, { id: 12, title: "اسفند" },
];
const years = [];
const YearEnd = parseInt(moment(new Date()).format('jYYYY')) - 15;
const YearStart = YearEnd - 68;
for (let index = YearEnd; index > YearStart; index--) {
    years.push(index);
}

function Register({ fn_close, isShow = true }) {
    const navigate = useNavigate();

    const [otp, setOtp] = useState('');
    const [Name, setName] = useState('');
    const [Family, setFamily] = useState('');
    const [NationalId, setNationalId] = useState('');
    const [Postcode, setPostcode] = useState('');
    const [Address, setAddress] = useState('');
    const [birthdayDay, setBirthdayDay] = useState(0);
    const [birthdayMonth, setBirthdayMonth] = useState(0);
    const [birthdaYear, setBirthdayYear] = useState(0);

    const [provinces, setProvinces] = useState([]);
    const [provinceId, setProvinceId] = useState(0);
    const [cityId, setCityId] = useState(0);

    const [mobile_verified_at, setMobileVerifiedAt] = useState(null);
    const [user_id, setUserId] = useState(null);
    const [Mobile, setMobile] = useState(null);
    const [disable, setDisable] = useState(false);

    // وضعیت تایید قوانین
    const [isAcceptRules, setIsAcceptRules] = useState(false);
    const [showRulesModal, setShowRulesModal] = useState(false);

    const [userShared, setUserShared] = useState(null);
    const [isSendCode, setIsSendCode] = useState(false);
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [isVerifyCode, setIsVerifyCode] = useState(false);
    const [timeCounter, setTimeCounter] = useState(lifeTime);
    const [isRunUser, setIsRunUser] = useState(false);

    const [user, setUser] = useState(null);
    const [isUserLoading, setIsUserLoading] = useState(false);

    const { ChatId } = useTelegram();

    // بررسی زنده وضعیت کد ملی
    const nationalCodeStatus = useMemo(() => {
        if (!NationalId || NationalId.length === 0) return null;
        if (NationalId.length < 10) {
            return {
                isComplete: false,
                isValid: false,
                lengthText: `${NationalId.length} / 10`
            };
        }
        const validation = validateNationalCode(NationalId, true);
        return {
            isComplete: true,
            isValid: Boolean(validation && validation.isValid),
            lengthText: '10 / 10'
        };
    }, [NationalId]);

    const fn_shared = (value) => {
        setUserShared(value);
        setIsSendCode(false);
        setOtp('');
        setIsVerifyCode(false);
        setTimeCounter(lifeTime);
    };

    useEffect(() => {
        const fetchProvinces = async () => {
            try {
                const response = await api.get('province/cities/all');
                if (response.data && response.data.data) {
                    setProvinces(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching provinces:", error);
            }
        };
        fetchProvinces();
    }, []);

    useEffect(() => {
        const fetchUser = async () => {
          //  if (!ChatId) return;

            setIsUserLoading(true);
            try {
                const response = await api.post('user/find');

                if (response.data && response.data.success) {
                    setUser(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching user:", error);
            } finally {
                setIsUserLoading(false);
            }
        };

        fetchUser();
    }, [ChatId, isRunUser]);

    useEffect(() => {
        if (user) {
            setUserId(user.id);
            setName(user.name || '');
            setFamily(user.family || '');
            setNationalId(user.national_code || '');
            setMobile(user.mobile);
            setPostcode(user.post_code || '');
            setAddress(user.address || '');
            setMobileVerifiedAt(user.mobile_verified_at);

            if (user.name && user.family) {
                setIsAcceptRules(true);
            }

            if (provinces.length > 0) {
                if (user.city_id) {
                    setCityId(user.city_id);
                    const foundProvince = provinces.find(prov =>
                        prov.cities && prov.cities.some(city => city.id === user.city_id)
                    );
                    if (foundProvince) {
                        setProvinceId(foundProvince.id);
                    } else if (user.province_id) {
                        setProvinceId(user.province_id);
                    }
                } else if (user.province_id) {
                    setProvinceId(user.province_id);
                }
            }

            if (user.birth_date) {
                setBirthdayDay(parseInt(moment(user.birth_date).format('jD')));
                setBirthdayMonth(parseInt(moment(user.birth_date).format('jM')));
                setBirthdayYear(parseInt(moment(user.birth_date).format('jYYYY')));
            } else {
                setBirthdayDay(0);
                setBirthdayMonth(0);
                setBirthdayYear(0);
            }

            if (user.mobile == null && user.mobile_Temp && user.mobile_Temp.length > 0 && user.mobile_verified_at == null) {
                setUserShared(user);
            }
        }
        sessionStorage.removeItem("counter_error_one_minute");
    }, [user, provinces]);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();

        if (!isAcceptRules) {
            toast.error('لطفاً قوانین و مقررات را تایید نمایید');
            return;
        }

        // اعتبارسنجی دقیق کد ملی
        const ncValidation = validateNationalCode(NationalId, true);
        if (!ncValidation || !ncValidation.isValid) {
            toast.error((ncValidation && ncValidation.message) || 'کد ملی وارد شده نامعتبر است');
            return;
        }

        if (!birthdayDay || !birthdayMonth || !birthdaYear ||
            birthdayDay === 0 || birthdayMonth === 0 || birthdaYear === 0) {
            toast.error('تاریخ تولد را وارد نمائید');
            return;
        }

        if (!provinceId || !cityId || provinceId === 0 || cityId === 0) {
            toast.error('لطفاً استان و شهرستان را انتخاب نمائید');
            return;
        }

        let jdateSet = `${birthdaYear}/${birthdayMonth}/${birthdayDay}`;

        setDisable(true);
        api.post(`user/update`, {
            name: Name,
            family: Family,
            birth_date: moment(jdateSet, 'jYYYY/jM/jD').format('YYYY-M-D HH:mm:ss'),
            post_code: Postcode,
            address: Address,
            national_code: NationalId,
            province_id: provinceId,
            city_id: cityId,
            isAcceptRules: isAcceptRules ? 1 : 0
        })
            .then((res) => {
                setDisable(false);
                const resData = res?.data ?? res;

                if (resData?.success) {
                    toast.success(resData?.message || resData?.data?.message || 'عملیات با موفقیت انجام شد');

                    setUser((prev) => ({
                        ...(prev || {}),
                        name: Name,
                        family: Family,
                        national_code: NationalId,
                        post_code: Postcode,
                        address: Address,
                        province_id: provinceId,
                        city_id: cityId,
                        birth_date: moment(jdateSet, 'jYYYY/jM/jD').format('YYYY-M-D HH:mm:ss')
                    }));

                    if (Name && Family) {
                        localStorage.setItem('isProfileComplete', 'true');
                        localStorage.setItem('isLogin', 'true');
                        window.dispatchEvent(new Event('profileUpdated'));
                        window.dispatchEvent(new Event('userLogin'));
                        window.dispatchEvent(new Event('loginChanged'));
                    }

                    setIsRunUser((prev) => !prev);
                } else {
                    toast.error(resData?.message || 'خطایی رخ داده است');
                }
            })
            .catch((error) => {
                setDisable(false);
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.data?.message ||
                    error?.message ||
                    'خطایی در ثبت اطلاعات رخ داد';

                toast.error(errorMessage);
            });
    };

    useEffect(() => {
        let intervalId = null;
        if (isSendCode) {
            intervalId = setInterval(() => {
                setTimeCounter((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(intervalId);
                        setIsSendCode(false);
                        setOtp('');
                        return lifeTime;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        } else {
            setTimeCounter(lifeTime);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isSendCode]);

    const fn_SendPhoneOtp = () => {
        setIsSendLoading(true);
        api.post(`phone/send/otp`, { chat_id: ChatId })
            .then((response) => {
                setIsSendLoading(false);
                if (response.data.success) {
                    setIsSendCode(true);
                    setTimeCounter(lifeTime);
                    setOtp('');
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                    setIsSendCode(false);
                }
            })
            .catch(() => setIsSendLoading(false));
    };

    const fn_VerifyPhoneOtp = () => {
        setIsVerifyCode(true);
        api.post(`phone/verify/otp`, { chat_id: ChatId, activeCode: otp })
            .then((response) => {
                setIsVerifyCode(false);
                if (response.data.success) {
                    toast.success(response.data.message);
                    setIsSendCode(false);
                    setUserShared(null);
                    setOtp('');
                    setIsRunUser(prev => !prev);
                } else {
                    toast.error(response.data.message);
                    setIsVerifyCode(false);
                }
            })
            .catch(() => setIsVerifyCode(false));
    };

    const eventToggleAdd = useCallback(() => {
        setUserShared(null);
        if (typeof fn_close === 'function') {
            fn_close();
        } else {
            navigate(-1);
        }
    }, [fn_close, navigate]);

    const showStep2 = userShared || (mobile_verified_at && !userShared);
    const isProfileComplete = Boolean(user && user.name && user.family);
    const isButtonDisabled = disable || !isAcceptRules;

    return (
        <Modal eventToggle={eventToggleAdd} isOpen={isShow} locked={true} fullscreen={true}>
            <div className='register-shop'>
                {/* ناحیه امن بالای تلگرام */}
                <TelegramSafeArea style={{ background: "#ffffff", color: "#000" }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: '1.3', padding: '6px 0' }}>
                        <span style={{ fontSize: '14px', fontWeight: 'bold' }}>سبد 1</span>
                        <span style={{ fontSize: '11px', opacity: 0.85 }}>ثبت نام / پروفایل کاربری</span>
                    </div>
                </TelegramSafeArea>

                {/* هدر ثابت فرم */}
                <div className="topbar">
                    <div className="formTitle">
                        <span>ثبت نام</span>
                    </div>

                    <div className="back" onClick={eventToggleAdd}>
                        <div className="btn-back"><IoMdArrowRoundBack size={"24px"} /></div>
                    </div>
                </div>

                {/* بخش اسکرول‌شونده اختصاصی */}
                <div className="context">
                    {isUserLoading ? (
                        <RegisterSkeleton />
                    ) : (
                        <div className="wrapper-context">
                            {/* مرحله ۱ */}
                            <div className="step-mobile-step">
                                <div className="title">
                                    <span>مرحله 1 : </span>
                                    <span>تایید شماره تلفن همراه</span>
                                </div>
                                <div className="btn-mobile-share">
                                    <div className="btn-title">
                                        <span>شماره تلفن همراه خود را تایید نمائید</span>
                                    </div>

                                    <PhoneAccessComponent
                                        fn_phoneAccess={fn_shared}
                                        ChatId={ChatId}
                                        isSendCode={isSendCode}
                                        isVerified={!!Mobile}
                                    />

                                    <div className="btn-footer">
                                        <span>شماره تلفن شما به صورت پیش فرض شماره ای است که حساب تلگرامی شما با آن ایجاد شده است </span>
                                    </div>
                                </div>
                            </div>

                            {/* مرحله ۲ */}
                            {showStep2 && (
                                <div className="step-mobile-step">
                                    {Mobile &&
                                        <div className="title">
                                            <span>مرحله 2 : </span>
                                            <span>احراز شماره تلفن همراه</span>
                                        </div>
                                    }
                                    {userShared &&
                                        <>
                                            {!isSendCode &&
                                                <div className="btn-mobile-share">
                                                    <div className="btn-title">
                                                        <span>شماره : {userShared.mobile_Temp} برای شما تایید شد</span>
                                                    </div>
                                                    <div className="btn-mobile" onClick={() => {
                                                        !isSendLoading && fn_SendPhoneOtp();
                                                    }}>
                                                        {!isSendLoading && <span>دریافت کد</span>}
                                                        {isSendLoading && <ReactLoading type={"spin"} color={"#FFFFFF"} height={25} width={25} />}
                                                    </div>
                                                    <div className="btn-footer">
                                                        <span>کد احراز شماره به شماره تایید شده شما ارسال میشود</span>
                                                    </div>
                                                </div>
                                            }
                                            {isSendCode &&
                                                <div className="btn-mobile-share">
                                                    <div className="btn-title">
                                                        <span>لطفا کد دریافتی را وارد نمایید</span><span>( {timeCounter} )</span>
                                                    </div>

                                                    <div className="otp-container">
                                                        <OTPInput
                                                            value={otp}
                                                            onChange={setOtp}
                                                            numInputs={5}
                                                            renderInput={(props) => <input {...props} />}
                                                            inputType='number'
                                                            shouldAutoFocus
                                                            containerStyle="otp-input-container"
                                                            inputStyle="otp-input"
                                                            focusStyle="otp-input-focus"
                                                        />
                                                    </div>

                                                    <div className="btn-mobile" onClick={() => {
                                                        if (!isVerifyCode)
                                                            fn_VerifyPhoneOtp();
                                                    }}>
                                                        {!isVerifyCode && <span>تایید</span>}
                                                        {isVerifyCode && <ReactLoading type={"spin"} color={"#FFFFFF"} height={25} width={25} />}
                                                    </div>
                                                    <div className="btn-footer">
                                                        <span>کد احراز شماره به شماره تایید شده شما ارسال میشود</span>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }

                                    {mobile_verified_at && !userShared &&
                                        <div className="step-mobile-confirm">
                                            <div className='ico'><FaCircleCheck color='#10b981' size="1.1rem" /></div>
                                            <div className="message">شماره : {Mobile} برای شما با موفقیت تاییدگردید.</div>
                                        </div>
                                    }
                                </div>
                            )}

                            {/* مرحله ۳ */}
                            {Mobile && (
                                <div className="step-mobile-step">
                                    <div className="title">
                                        <div className="title-text">
                                            <span>مرحله 3 : </span>
                                            <span>اطلاعات تکمیلی</span>
                                        </div>
                                        {!isProfileComplete && (
                                            <span className="step-subtitle-hint">
                                                (مشخصات را به زبان فارسی وارد نمائید)
                                            </span>
                                        )}
                                    </div>

                                    {isProfileComplete && (
                                        <div className="step-mobile-confirm" style={{ marginBottom: '1rem' }}>
                                            <div className='ico'><FaCircleCheck color='#10b981' size="1.1rem" /></div>
                                            <div className="message">
                                                مشخصات کاربری ({user?.name} {user?.family}) با موفقیت تایید و ثبت گردید.
                                            </div>
                                        </div>
                                    )}

                                    <div className="btn-mobile-share">
                                        <div className="inputBox-register">
                                            <div className="input-label">نام :</div>
                                            <div className="inputControl">
                                                <input type='text' placeholder='نام خود را وارد کنید' value={Name} onChange={(e) => setName(e.target.value)} required />
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">نام خانوادگی :</div>
                                            <div className="inputControl">
                                                <input type='text' placeholder='نام خانوادگی خود را وارد کنید' value={Family} onChange={(e) => setFamily(e.target.value)} required />
                                            </div>
                                        </div>

                                        {/* فیلد کد ملی با نشانگر وضعیت در بالای باکس و آیکون داخل باکس */}
                                        <div className="inputBox-register">
                                            <div className="input-label" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span>کدملی :</span>
                                                {nationalCodeStatus && (
                                                    <span style={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        direction: 'ltr',
                                                        color: !nationalCodeStatus.isComplete
                                                            ? '#6b7280'
                                                            : nationalCodeStatus.isValid
                                                                ? '#10b981'
                                                                : '#ef4444'
                                                    }}>
                                                        {!nationalCodeStatus.isComplete
                                                            ? nationalCodeStatus.lengthText
                                                            : (nationalCodeStatus.isValid ? 'معتبر' : 'نامعتبر')}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="inputControl" style={{ position: 'relative' }}>
                                                <NumericFormat
                                                    placeholder='کد ملی ۱۰ رقمی'
                                                    isAllowed={(values) => {
                                                        const { value } = values;
                                                        return value.length <= 10;
                                                    }}
                                                    value={NationalId}
                                                    allowLeadingZeros
                                                    onValueChange={(values) => {
                                                        setNationalId(values.value);
                                                    }}
                                                    required
                                                />
                                                {nationalCodeStatus && (
                                                    <div style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                                                        {nationalCodeStatus.isValid ? (
                                                            <FaCircleCheck color="#10b981" size="1.1rem" />
                                                        ) : (
                                                            <FaCircleXmark color="#ef4444" size="1.1rem" />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">تاریخ تولد :</div>
                                            <div className="inputControl date">
                                                <div className="birth-day">
                                                    <select
                                                        className='day'
                                                        value={birthdayDay}
                                                        onChange={(e) => setBirthdayDay(Number(e.target.value))}
                                                        style={{ color: birthdayDay === 0 ? '#9ca3af' : 'inherit' }}
                                                    >
                                                        <option value="0" disabled hidden>روز</option>
                                                        {days.map(day => <option key={day} value={day}>{day}</option>)}
                                                    </select>
                                                    <select
                                                        className='month'
                                                        value={birthdayMonth}
                                                        onChange={(e) => setBirthdayMonth(Number(e.target.value))}
                                                        style={{ color: birthdayMonth === 0 ? '#9ca3af' : 'inherit' }}
                                                    >
                                                        <option value="0" disabled hidden>ماه</option>
                                                        {months.map(m => <option key={m.id} value={m.id}>{m.title}</option>)}
                                                    </select>
                                                    <select
                                                        className='year'
                                                        value={birthdaYear}
                                                        onChange={(e) => setBirthdayYear(Number(e.target.value))}
                                                        style={{ color: birthdaYear === 0 ? '#9ca3af' : 'inherit' }}
                                                    >
                                                        <option value="0" disabled hidden>سال</option>
                                                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">استان :</div>
                                            <div className="inputControl">
                                                <select
                                                    value={provinceId}
                                                    onChange={(e) => {
                                                        setProvinceId(Number(e.target.value));
                                                        setCityId(0);
                                                    }}
                                                    style={{ color: provinceId === 0 ? '#9ca3af' : 'inherit' }}
                                                >
                                                    <option value="0" disabled hidden>انتخاب استان</option>
                                                    {provinces.map(prov => (
                                                        <option key={prov.id} value={prov.id}>{prov.title}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">شهرستان :</div>
                                            <div className="inputControl">
                                                <select
                                                    value={cityId}
                                                    onChange={(e) => setCityId(Number(e.target.value))}
                                                    disabled={provinceId === 0}
                                                    style={{ color: cityId === 0 ? '#9ca3af' : 'inherit' }}
                                                >
                                                    <option value="0" disabled hidden>انتخاب شهرستان</option>
                                                    {provinces
                                                        .find(prov => prov.id === provinceId)?.cities
                                                        ?.map(city => (
                                                            <option key={city.id} value={city.id}>{city.title}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">کد پستی :</div>
                                            <div className="inputControl">
                                                <NumericFormat
                                                    placeholder='کد پستی ۱۰ رقمی'
                                                    isAllowed={(values) => {
                                                        const { floatValue } = values;
                                                        return (floatValue > 0 && floatValue <= 9999999999) || floatValue == null;
                                                    }}
                                                    value={Postcode}
                                                    allowLeadingZeros
                                                    onValueChange={(values) => {
                                                        setPostcode(values.value);
                                                    }}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="inputBox-register">
                                            <div className="input-label">آدرس کامل :</div>
                                            <div className="inputControl address">
                                                <textarea placeholder='آدرس دقیق پستی' rows="3" value={Address} onChange={(e) => setAddress(e.target.value)} required></textarea>
                                            </div>
                                            <div className="footer-hint">
                                                <span>* آدرس و کد پستی در هنگام ثبت فاکتور قابل تغییر می‌باشد اما به صورت پیش‌فرض اطلاعات فوق درج می‌گردد.</span>
                                            </div>
                                        </div>

                                        {/* تایید قوانین و مقررات */}
                                        <div className="rules-accept-container">
                                            <input
                                                type="checkbox"
                                                id="rulesCheckbox"
                                                checked={isAcceptRules}
                                                onChange={(e) => setIsAcceptRules(e.target.checked)}
                                                className="rules-checkbox-input"
                                            />
                                            <label htmlFor="rulesCheckbox" className="rules-checkbox-label">
                                                <span
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setShowRulesModal(true);
                                                    }}
                                                    className="rules-link"
                                                >
                                                    قوانین و مقررات
                                                </span>
                                                {' '}را مطالعه نموده و می‌پذیرم.
                                            </label>
                                        </div>


                                        {/* دکمه ثبت / بروزرسانی */}
                                        <div
                                            className={`btn-mobile ${isButtonDisabled ? 'disabled' : ''}`}
                                            onClick={!isButtonDisabled ? handleSubmit : undefined}
                                        >
                                            {disable ? (
                                                <ReactLoading type={"spin"} color={"#FFFFFF"} height={25} width={25} />
                                            ) : (
                                                <span>{isProfileComplete ? 'بروزرسانی مشخصات' : 'ثبت مشخصات'}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* مودال قوانین و مقررات */}
                {showRulesModal && (
                    <div className="rules-modal-overlay">
                        <div className="rules-modal-box">
                            <div className="rules-modal-header">
                                <span>قوانین و مقررات سامانه</span>
                                <div className="rules-modal-close" onClick={() => setShowRulesModal(false)}>
                                    <IoMdClose size={22} color="#666" />
                                </div>
                            </div>

                            <div className="rules-modal-content">
                                <p><strong>۱. شرایط و ضوابط عمومی:</strong> استفاده از خدمات این سامانه به معنای آگاهی کامل و پذیرش کلیه قوانین فروشگاه و مقررات جاری کشور می‌باشد.</p>
                                <p><strong>۲. صحت اطلاعات:</strong> کاربر متعهد می‌گردد که اطلاعات هویتی و شماره تماس خود را به صورت دقیق و واقعی وارد نماید. مسئولیت هرگونه مغایرت متوجه کاربر خواهد بود.</p>
                                <p><strong>۳. حفظ حریم خصوصی:</strong> اطلاعات ثبت شده کاربران نزد سامانه به صورت کاملاً امن نگهداری شده و در اختیار اشخاص ثالث قرار نخواهد گرفت.</p>
                                <p><strong>۴. پیگیری سفارشات:</strong> کلیه پیام‌ها و فاکتورها به شماره تماس تأییدشده ارسال خواهد گردید.</p>
                            </div>

                            <div className="rules-modal-footer">
                                <button
                                    type="button"
                                    className="rules-modal-accept-btn"
                                    onClick={() => {
                                        setIsAcceptRules(true);
                                        setShowRulesModal(false);
                                    }}
                                >
                                    مطالعه شد و می‌پذیرم
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}

export default Register;
